import { render } from "./InfinityPreloader.vue?vue&type=template&id=528fc93e&scoped=true"
import script from "./InfinityPreloader.vue?vue&type=script&lang=js"
export * from "./InfinityPreloader.vue?vue&type=script&lang=js"

import "./InfinityPreloader.vue?vue&type=style&index=0&id=528fc93e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528fc93e"]])

export default __exports__